<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">{{title}}</div>
                <hr class="dialog-hr">

                <div class="dialog-body-small">
                    <el-form label-width="170px" class="dialog-form-item" :model="form" :rules="rules" ref="form">
                        <el-form-item prop="password">
                            <span slot="label">{{label}}</span>
                            <el-input v-model="form.password" show-password></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <hr class="dialog-hr">

                <div class="dialog-button-field">
                    <el-button @click="$emit('onCancel')" class="dialog-cancel-button" type="button">{{$t('message.button_cancel')}}</el-button>
                    <el-button @click="onSave()" class="dialog-ok-button" :disabled="this.$data.disableButton">{{$t('message.button_save')}}</el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from './common-validate.js';

export default {
    data() {
        var validatePass = (rule, value, callback) => {
            let validateResult = commonValidate.validateItem(this.$i18n, "password", value)
            if (validateResult.valid) {
                callback()
            } else {
                callback(new Error(validateResult.message))
            }
        };
        return {
            form: {
                password: null
            },
            rules: {
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        }
    },
    methods : {
        onSave : function() {
            this.$refs['form'].validate((valid) => {
              if (valid) {
                 this.$emit('onSave', this.form.password)
              } else {
                return false;
              }
            });
        }
    },
    props: {
        title: {
            type: String,
            default: 'title!!'
        },
        label: {
            type: String,
            default: "label!!"
        },
    }
}
</script>

<style scoped>
</style>
